import React from 'react';

/**
 * The status dot, in the two places the Activity screen shows health.
 *
 * Beside a function in the Function filter, and beside a state in the table.
 * One component for both so the colours cannot drift apart: a reader who
 * learns amber in the filter has learnt amber in the table.
 *
 * `tone` is one of `good`, `warn`, `changed`, `bad`, `muted` — the vocabulary
 * AiActivityService's descriptors are written in. AMBER (`warn`) MEANS A HUMAN
 * IS NEEDED, never that something crashed; a break is `bad`, and red.
 *
 * COLOUR IS NOT A LABEL, so every use of this sits next to the word it
 * colours and the dot itself is `aria-hidden`. `title` carries the count or
 * the reason for a sighted reader hovering it, and is never the only place a
 * fact lives.
 */
function AiStatusDot({ tone = 'muted', title }) {
  return (
    <span
      className={`ai-dot ai-dot--${tone}`}
      title={title}
      aria-hidden="true"
    />
  );
}

export default AiStatusDot;
